module.exports = __webpack_public_path__ + "static/img/far1_active.f4f462ff.png";